import { render, staticRenderFns } from "./ResultMaterialsComputation.vue?vue&type=template&id=40b97666&scoped=true&"
import script from "./ResultMaterialsComputation.vue?vue&type=script&lang=js&"
export * from "./ResultMaterialsComputation.vue?vue&type=script&lang=js&"
import style0 from "./ResultMaterialsComputation.vue?vue&type=style&index=0&id=40b97666&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b97666",
  null
  
)

export default component.exports